import { z } from 'zod';
import { ServiceLineSchema } from './opportunities';
// ---------- F35 Catálogo de Productos/Servicios ----------
export const ProductKindSchema = z.enum(['PRODUCTO', 'SERVICIO', 'SUSCRIPCION', 'LICENCIA']);
export const ProductKindLabel = {
    PRODUCTO: 'Producto',
    SERVICIO: 'Servicio',
    SUSCRIPCION: 'Suscripción',
    LICENCIA: 'Licencia',
};
export const ProductUnitSchema = z.enum([
    'UD',
    'HORA',
    'DIA',
    'MES',
    'TRIMESTRE',
    'ANIO',
    'LICENCIA',
]);
export const ProductUnitLabel = {
    UD: 'ud',
    HORA: 'h',
    DIA: 'día',
    MES: 'mes',
    TRIMESTRE: 'trimestre',
    ANIO: 'año',
    LICENCIA: 'licencia',
};
// M11 — unificado con el schema canónico (catálogo service_line en BD).
export const ProductServiceLineSchema = ServiceLineSchema;
const PRODUCT_CODE_REGEX = /^[A-Z0-9-]+$/;
const CENTS_MAX = 100_000_000;
export const ProductDtoSchema = z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    kind: ProductKindSchema,
    unit: ProductUnitSchema,
    unitPriceCents: z.number().int(),
    defaultCostCents: z.number().int(),
    vatRateBps: z.number().int(),
    irpfRateBps: z.number().int(),
    serviceLine: ProductServiceLineSchema.nullable(),
    revenueAccountCode: z.string().nullable(),
    active: z.boolean(),
    position: z.number().int(),
    createdAt: z.string().datetime(),
});
export const CreateProductSchema = z.object({
    code: z
        .string()
        .trim()
        .min(3)
        .max(32)
        .regex(PRODUCT_CODE_REGEX, 'Solo mayúsculas, dígitos y guion'),
    name: z.string().trim().min(2).max(200),
    description: z.string().max(2000).nullable().optional(),
    kind: ProductKindSchema,
    unit: ProductUnitSchema.default('UD'),
    unitPriceCents: z.number().int().min(0).max(CENTS_MAX).default(0),
    defaultCostCents: z.number().int().min(0).max(CENTS_MAX).default(0),
    vatRateBps: z.number().int().min(0).max(10000).default(2100),
    irpfRateBps: z.number().int().min(0).max(10000).default(0),
    serviceLine: ProductServiceLineSchema.nullable().optional(),
    revenueAccountCode: z.string().max(10).nullable().optional(),
    position: z.number().int().min(0).default(0),
});
export const UpdateProductSchema = z
    .object({
    code: z
        .string()
        .trim()
        .min(3)
        .max(32)
        .regex(PRODUCT_CODE_REGEX, 'Solo mayúsculas, dígitos y guion')
        .optional(),
    name: z.string().trim().min(2).max(200).optional(),
    description: z.string().max(2000).nullable().optional(),
    kind: ProductKindSchema.optional(),
    unit: ProductUnitSchema.optional(),
    unitPriceCents: z.number().int().min(0).max(CENTS_MAX).optional(),
    defaultCostCents: z.number().int().min(0).max(CENTS_MAX).optional(),
    vatRateBps: z.number().int().min(0).max(10000).optional(),
    irpfRateBps: z.number().int().min(0).max(10000).optional(),
    serviceLine: ProductServiceLineSchema.nullable().optional(),
    revenueAccountCode: z.string().max(10).nullable().optional(),
    position: z.number().int().min(0).optional(),
    active: z.boolean().optional(),
})
    .refine((d) => Object.keys(d).length > 0, { message: 'Sin cambios' });
export const ProductListResponseSchema = z.object({
    items: z.array(ProductDtoSchema),
});
//# sourceMappingURL=products.js.map